module.exports = __webpack_public_path__ + "images/檀程长图_01.jpg?v=cb635b6f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_01.jpg
 ** module id = 187
 ** module chunks = 1 2
 **/